import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { UserDialogView } from 'src/app/landing-page/landing-page.modal';
import * as landingPageActions from '../actions/landing-page.actions';
import { LandingPageSelectors } from '../selectors/landing-page.selectors';
import {
  ContactUsDetails,
  FPDetails,
  LandingPageState,
  SignInDetails,
  SignUpDetails,
} from '../state/landing-page.state';

@Injectable({
  providedIn: 'root',
})
export class LandingPageFacade {
  activeSignButton$ = this.selector.getActiveSignButton$;
  getMobileNavigationMenu$ = this.selector.getMobileNavigationMenu$;
  getDesktopNavigationMenu$ = this.selector.getDesktopNavigationMenu$;
  signInDetails$ = this.selector.getSignInDetails$;
  signUpDetails$ = this.selector.getSignUpDetails$;
  isPasswordUpdated$ = this.selector.getIsPasswordUpdated$;
  isOTPRequested$ = this.selector.isOTPRequested$;
  contactUsRequestStatus$ = this.selector.contactUsRequestStatus$;
  signInRequestStatus$ = this.selector.signInRequestStatus$;
  signUpRequestStatus$ = this.selector.signUpRequestStatus$;
  requestOTPRequestStatus$ = this.selector.requestOTPRequestStatus$;
  changePasswordRequestStatus$ = this.selector.changePasswordRequestStatus$;
  reactivateKey$ = this.selector.reactivateKey$;
  reactivateAccountResponse$ = this.selector.reactivateAccountResponse$;
  reactivateAccountRequestStatus$ =
    this.selector.reactivateAccountRequestStatus$;
  reactivateAccountErrorMessage$ = this.selector.reactivateAccountErrorMessage$;

  constructor(
    private store: Store<LandingPageState>,
    private selector: LandingPageSelectors,
  ) {}

  setActiveSignButton(activeSignButton: UserDialogView): void {
    this.store.dispatch(
      landingPageActions.setActiveSignButton({ activeSignButton }),
    );
  }

  signIn(signInDetails: SignInDetails): void {
    this.store.dispatch(landingPageActions.signIn({ signInDetails }));
  }

  signUp(signUpDetails: SignUpDetails): void {
    this.store.dispatch(landingPageActions.signUp({ signUpDetails }));
  }

  requestOTP(emailId: string): void {
    this.store.dispatch(landingPageActions.requestOTP({ emailId }));
  }

  setReactivateKey(reactivateKey: string | null): void {
    this.store.dispatch(landingPageActions.setReactivateKey({ reactivateKey }));
  }

  reactivateAccount(reactivateKey: string): void {
    this.store.dispatch(
      landingPageActions.reactivateAccount({ reactivateKey }),
    );
  }

  setReactivateAccountError(errorMessage: string): void {
    this.store.dispatch(
      landingPageActions.reactivateAccountError({ errorMessage }),
    );
  }

  resetReactivateAccountState(): void {
    this.store.dispatch(landingPageActions.resetReactivateAccountState());
  }

  resetPassword(fpDetails: FPDetails): void {
    this.store.dispatch(landingPageActions.resetPassword({ fpDetails }));
  }

  submitContactUs(contactUsDetails: ContactUsDetails): void {
    this.store.dispatch(
      landingPageActions.submitContactUs({ contactUsDetails }),
    );
  }

  resetContactUsRequestStatus(): void {
    this.store.dispatch(landingPageActions.resetContactUsRequestStatus());
  }

  resetSignInRequestStatus(): void {
    this.store.dispatch(landingPageActions.resetSignInRequestStatus());
  }

  resetSignUpRequestStatus(): void {
    this.store.dispatch(landingPageActions.resetSignUpRequestStatus());
  }

  resetRequestOTPRequestStatus(): void {
    this.store.dispatch(landingPageActions.resetRequestOTPRequestStatus());
  }

  resetChangePasswordRequestStatus(): void {
    this.store.dispatch(landingPageActions.resetChangePasswordRequestStatus());
  }
}
